// extracted by mini-css-extract-plugin
module.exports = {"upload_container":"ProgramForm_upload_container__kYRvi","logo_preview":"ProgramForm_logo_preview__3KibD","delete_icon":"ProgramForm_delete_icon__3sRpY"};